import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=047d9c12&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=047d9c12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047d9c12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('047d9c12')) {
      api.createRecord('047d9c12', component.options)
    } else {
      api.reload('047d9c12', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=047d9c12&scoped=true&", function () {
      api.rerender('047d9c12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26cl9JfAy4Ydw/JS/comp/PopupDialog.vue"
export default component.exports